<div class="card incidencia-ia-ticket-modal incidencia-ia-detalle-modal">
  <div class="card-header card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h4 class="card-title"><b>Detalle incidencia IA</b></h4>
        <p class="card-category">
          Vista de seguimiento ISO/IEC 42001
          <span *ngIf="incidencia?.idIncidenciaIa"> - Folio <strong>#{{ incidencia?.idIncidenciaIa }}</strong></span>
        </p>
      </div>
      <div class="col-sm-12 col-md-1 text-right">
        <button type="button" mat-icon-button aria-label="Cerrar" (click)="cerrarDetalle()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="wraper">
      <div class="container">
        <div class="alert alert-danger incidencia-ia-ticket-modal__alert" *ngIf="error">
          <i class="material-icons">error_outline</i>
          <span>{{ error }}</span>
        </div>

        <div class="alert alert-warning incidencia-ia-ticket-modal__alert" *ngIf="advertencia">
          <i class="material-icons">warning_amber</i>
          <span>{{ advertencia }}</span>
        </div>

        <div class="text-center text-muted my-4" *ngIf="cargando && !incidencia">
          <i class="material-icons">hourglass_top</i>
          <strong>Cargando…</strong>
        </div>

        <div class="text-center text-muted my-4" *ngIf="!cargando && !incidencia">
          <i class="material-icons">error_outline</i>
          <strong>No se encontró el registro.</strong>
        </div>

        <ng-container *ngIf="incidencia">
          <section class="incidencia-ia-detalle-section" [class.is-open]="seccionAbierta('resumen')">
            <button type="button" class="incidencia-ia-detalle-section__header" (click)="toggleSeccion('resumen')">
              <div class="incidencia-ia-detalle-section__title">
                <i class="material-icons">assignment_late</i>
                <span>Resumen</span>
              </div>
              <span
                class="incidencia-ia-detalle-section__status"
                [style.--estado-color]="estadoColor(incidencia.estadoEvento)"
              >
                {{ estadoTitulo(incidencia.estadoEvento) }}
              </span>
              <i class="material-icons incidencia-ia-detalle-section__chevron">expand_more</i>
            </button>
            <div class="detalle-grid" *ngIf="seccionAbierta('resumen')">
              <div class="detalle-item">
                <span>Herramienta IA</span>
                <strong>{{ valor(incidencia.herramientaIaConsecutivo) }} - {{ valor(incidencia.herramientaIaNombre) }}</strong>
              </div>
              <div class="detalle-item">
                <span>Fecha apertura</span>
                <strong>{{ incidencia.fechaApertura ? (incidencia.fechaApertura | date: "dd/MM/yyyy HH:mm") : "-" }}</strong>
              </div>
              <div class="detalle-item">
                <span>Notificado por</span>
                <strong>{{ valor(incidencia.notificadoPor) }}</strong>
              </div>
              <div class="detalle-item">
                <span>Proyecto, sistema o actividad</span>
                <strong>{{ valor(incidencia.proyectoSistemaActividad) }}</strong>
              </div>
              <div class="detalle-item detalle-item--full">
                <span>Descripción del evento</span>
                <strong>{{ valor(incidencia.descripcionEvento) }}</strong>
              </div>
            </div>
          </section>

          <section class="incidencia-ia-detalle-section" [class.is-open]="seccionAbierta('clasificacion')">
            <button type="button" class="incidencia-ia-detalle-section__header" (click)="toggleSeccion('clasificacion')">
              <div class="incidencia-ia-detalle-section__title">
                <i class="material-icons">priority_high</i>
                <span>Clasificación</span>
              </div>
              <i class="material-icons incidencia-ia-detalle-section__chevron">expand_more</i>
            </button>
            <div class="detalle-grid" *ngIf="seccionAbierta('clasificacion')">
              <div class="detalle-item"><span>Tipo de evento</span><strong>{{ labelTipoEvento(incidencia.tipoEvento) }}</strong></div>
              <div class="detalle-item"><span>Gravedad</span><strong>{{ labelGravedad(incidencia.gravedad) }}</strong></div>
              <div class="detalle-item"><span>Prioridad</span><strong>{{ labelPrioridad(incidencia.prioridad) }}</strong></div>
              <div class="detalle-item"><span>Fecha atención</span><strong>{{ incidencia.fechaAtencion ? (incidencia.fechaAtencion | date: "dd/MM/yyyy HH:mm") : "-" }}</strong></div>
              <div class="detalle-item detalle-item--full"><span>Riesgo identificado</span><strong>{{ valor(incidencia.riesgoIdentificado) }}</strong></div>
              <div class="detalle-item detalle-item--full"><span>Impacto</span><strong>{{ valor(incidencia.impacto) }}</strong></div>
            </div>
          </section>

          <section class="incidencia-ia-detalle-section" [class.is-open]="seccionAbierta('seguimiento')">
            <button type="button" class="incidencia-ia-detalle-section__header" (click)="toggleSeccion('seguimiento')">
              <div class="incidencia-ia-detalle-section__title">
                <i class="material-icons">fact_check</i>
                <span>Causa / Origen</span>
              </div>
              <i class="material-icons incidencia-ia-detalle-section__chevron">expand_more</i>
            </button>
            <div class="detalle-grid" *ngIf="seccionAbierta('seguimiento')">
              <div class="detalle-item detalle-item--full">
                <span>Causa / Origen</span>
                <div class="incidencia-ia-porques-detalle" *ngIf="porquesDetalle().length; else sinPorques">
                  <div class="incidencia-ia-porque-detalle" *ngFor="let porque of porquesDetalle()">
                    <small>{{ porque.numero }}</small>
                    <div>
                      <strong>{{ porque.pregunta }}</strong>
                      <p>{{ porque.respuesta }}</p>
                    </div>
                  </div>
                </div>
                <ng-template #sinPorques>
                  <strong>-</strong>
                </ng-template>
              </div>
              <div class="detalle-item detalle-item--full"><span>Acción correctiva</span><strong>{{ valor(incidencia.accionCorrectiva) }}</strong></div>
              <div class="detalle-item"><span>Responsable resolución</span><strong>{{ valor(incidencia.responsableResolucion) }}</strong></div>
              <div class="detalle-item">
                <span>Fecha planeada resolución</span>
                <strong>{{ incidencia.fechaPlaneadaResolucion ? (incidencia.fechaPlaneadaResolucion | date: "dd/MM/yyyy") : "-" }}</strong>
              </div>
              <div class="detalle-item"><span>Perfil responsable seguimiento</span><strong>{{ valor(incidencia.responsableSeguimientoPerfil || incidencia.responsableSeguimientoCargo) }}</strong></div>
              <div class="detalle-item"><span>Responsable seguimiento</span><strong>{{ valor(incidencia.nombreResponsableSeguimiento) }}</strong></div>
              <div class="detalle-item detalle-item--full"><span>Validación humana realizada</span><strong>{{ valor(incidencia.validacionHumanaRealizada) }}</strong></div>
              <div class="detalle-item detalle-item--full">
                <span>Observaciones</span>
                <div class="incidencia-ia-comments-detalle" *ngIf="comentarios.length; else sinComentariosDetalle">
                  <div class="incidencia-ia-comment-detalle" *ngFor="let comentario of comentarios; trackBy: trackByComentario">
                    <div>
                      <strong>{{ comentario.nombreUsuario || "Usuario" }}</strong>
                      <small>{{ comentario.fechaComentario ? (comentario.fechaComentario | date: "dd/MM/yyyy HH:mm") : "-" }}</small>
                    </div>
                    <p>{{ comentario.comentario }}</p>
                  </div>
                </div>
                <ng-template #sinComentariosDetalle>
                  <strong>-</strong>
                </ng-template>
              </div>
            </div>
          </section>

          <section class="incidencia-ia-detalle-section" [class.is-open]="seccionAbierta('historial')">
            <button type="button" class="incidencia-ia-detalle-section__header" (click)="toggleSeccion('historial')">
              <div class="incidencia-ia-detalle-section__title">
                <i class="material-icons">history</i>
                <span>Historial</span>
              </div>
              <i class="material-icons incidencia-ia-detalle-section__chevron">expand_more</i>
            </button>
            <ng-container *ngIf="seccionAbierta('historial')">
            <div class="incidencia-ia-detalle-empty" *ngIf="cargandoHistorial; else historialContenido">
              <i class="material-icons">hourglass_top</i>
              <p>Cargando historial...</p>
            </div>
            <ng-template #historialContenido>
            <div class="table-page__table-wrap" *ngIf="historial.length; else sinHistorial">
              <table class="table-page__table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Acción</th>
                    <th>Campo</th>
                    <th>Anterior</th>
                    <th>Nuevo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of historial">
                    <td>{{ item.fechaCambio ? (item.fechaCambio | date: "dd/MM/yyyy HH:mm") : "-" }}</td>
                    <td><strong class="table-page__name">{{ valor(item.accion) }}</strong></td>
                    <td>{{ valor(item.campoModificado) }}</td>
                    <td><span class="table-page__text">{{ valor(item.valorAnterior) }}</span></td>
                    <td><span class="table-page__text">{{ valor(item.valorNuevo) }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #sinHistorial>
              <div class="incidencia-ia-detalle-empty">
                <i class="material-icons">history</i>
                <p>Sin movimientos registrados.</p>
              </div>
            </ng-template>
            </ng-template>
            </ng-container>
          </section>
        </ng-container>

        <div class="row">
          <div class="col-sm-12">
            <div mat-dialog-actions class="justify-content-end incidencia-ia-detalle-actions">
              <button type="button" mat-button class="btn btn-default" (click)="cerrarDetalle()">
                <i class="fa fa-times-circle-o"></i> Cerrar
              </button>
              <button
                type="button"
                mat-button
                class="btn btn-info"
                (click)="editar()"
                [disabled]="!puedeEditar()"
              >
                Editar <i class="material-icons">edit</i>
              </button>
              <button
                type="button"
                mat-button
                class="btn btn-warning"
                *ngIf="puedeRegresarAProceso()"
                (click)="regresarAProceso()"
                [disabled]="cambiandoEstado"
              >
                Regresar a proceso <i class="material-icons">undo</i>
              </button>
              <button
                type="button"
                mat-button
                class="btn btn-success incidencia-ia-detalle-actions__primary"
                (click)="cambiarEstado()"
                [disabled]="!puedeCambiarEstado() || cambiandoEstado"
              >
                {{ cambiandoEstado ? "Actualizando…" : siguienteEstadoTexto() }}
                <i class="material-icons">published_with_changes</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
